var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-schedule-tab"},[_c('h3',[_vm._v("Schedule")]),_c('credits-history',{attrs:{"credits-balance":_vm.creditsBalance,"credits-history":_vm.creditsHistory}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }